<template>
    <div class="stat">
        <sendStatisticRating
                key="sendStatisticsModal"
                v-if="sendStatisticsModal"
                @close="sendStatisticsModal = false"
                @white_button="sendStatisticsModal = false"
                @yellow_button="send_total"
                :text="'Вы точно хотите отправить данные?'"
                :button_text_firs="'Отменить'"
                :button_text_second="'Отправить'"
                class="z-50 flex"
                modalClasses="max-w-105"
                textClasses="px-12"
        />
        <stat-modal-text
            v-if="text_modal"
            :modal_data="modal_data"
            :error_text="error_text"
            :error_header="error_header"
            @close="closeTextModal"/>
        <statList ref="stat_events" v-for="event in seria"
                :event="event"
                :number_of_events="seria.length"
                :getAllEvents="stat_events"
                :key="event.uuid"
                :city="formCity"
                :userRole="userRole"
                @reject="rejectPartial"
                @registations_total="registations_count($event)"
                @updateEvent="$emit('updateEvent')"
                @applications_send="total_send($event)"
                @applications_update="set_applications($event)"
                @open_ref="refs_opened++"
                @close_ref="refs_opened--"
                @applications_update_minus="set_applications($event)"/>
        <div class="flex">
            <on-click-outside :do="close_popover">
                <button :disabled="!buttonEnabled"
                        v-if="userRole !== 'event_organizer'"
                        @click="show_confirm" ref="confirm"
                        :class="[ buttonEnabled ? 'bg-brand-light hover:border-brand-yellow hover:bg-brand-yellow hover:text-white' : 'bg-menuOrder-gray-light']"
                        class="mt-6 mx-auto md:ml-auto border border-transparent outline-none font-semibold text-sm rounded-full text-white md:mr-2 relative button-stat py-3 ml-auto md:mr-10"
                >Отправить статистику
                <div class="absolute text-menuOrder-dark-blue text-xs mb-2 bg-white border-additional-text border p-2 z-20 rounded-lg font-medium"
                     ref="warning" v-show="pop_is_open">
                    Нельзя отправить статистику, так как не все игры серии завершены
                </div>
                </button>
            </on-click-outside>
        </div>
      <ratingStatisticModal
          :gameEventRecordId="eventRecordId"
          @close_all_modals="showRatingModal = false; $emit('updateEvent');"
          @close_only_stat_sent="showRatingModal = false;text_modal = true"
          v-if="showRatingModal">
      </ratingStatisticModal>
    </div>
</template>

<script>
import Popper from 'popper.js';
import OnClickOutside from '@/views/OnClickOutside.vue';
import ratingStatisticModal from '@/views/modals/ratingStatisticModal.vue';
import client from '@/clients/partners';
import cloneDeep from 'lodash/cloneDeep';
import statList from './stat-list.vue';
import sendStatisticRating from '../../data-base/confirm-delete.vue';
import statModalText from './stat-modal/stat-text.vue';

export default {
  name: 'stat-seria',
  props: ['statSeria', 'stat_events', 'formCity', 'seria', 'serias', 'userRole', 'eventRecordId'],
  components: {
    statList,
    sendStatisticRating,
    statModalText,
    OnClickOutside,
    ratingStatisticModal,
  },
  data() {
    return {
      sendStatisticsModal: false,
      modal_data: {},
      text_modal: false,
      error_text: 'Мы обнаружили некорректные данные. Проверьте заполненные поля.',
      error_header: 'Отправка статистики невозможна!',
      applications: [], // эта хрень постоянно undefined, разобраться зачем она
      total_count: 0,
      temp: '',
      refs_opened: 0, // Количество открытых карточек
      child_len: 0, // Количество карточек
      stat_total: {},
      pop_is_open: false,
      all_results_filled: false,
      showRatingModal: false,
    };
  },
  mounted() {
    this.child_len = this.$children.length - 1;
  },
  created() {
    this.allResultsFilled();
  },
  methods: {
    total_send(ev) {
      Object.keys(ev).forEach((item) => {
        this.stat_total[item] = ev[item];
      });
    },
    show_confirm() {
      if (this.seria_length !== this.seria.length && !this.allEventsStatFill) {
        this.show_popover();
        return;
      }
      this.$refs.stat_events.forEach((item) => {
        if (!(item.applications && item.applications.length === item.registration_date.length)) {
          this.modal_data.reject = true;
          this.text_modal = true;
        } else this.sendStatisticsModal = true;
      });
    },
    registations_count(data) {
      this.total_count = data.length;
    },
    send_total() {
      client
        .patch(`applications/events/${this.seria[0].event_record_id}/statistic/send`, {
          event_dates: this.stat_total,
          all_events_fill: this.allEventsStatFill,
        })
        .then(() => {
          this.openSuccessModal();
        })
        .catch((e) => {
          if (e.response.data.errors &&
              e.response.data.errors.applications &&
              e.response.data.errors.applications[0] &&
              e.response.data.errors.applications[0] === 'По прошедшим играм нельзя отправить нулевую статистику. Если у вас не было игр, отправьте заявку на ее удаление') {
            this.error_text = 'По прошедшим играм нельзя отправить нулевую статистику. Если у вас не было игр, отправьте заявку на ее удаление';
          }
          this.openRejectModal();
        });
      this.$nextTick(() => {});
    },
    rejectPartial() {
      this.error_text = 'По прошедшим играм нельзя отправить нулевую статистику. Если у вас не было игр, отправьте заявку на ее удаление';
      this.openRejectModal();
    },
    openRejectModal() {
      this.sendStatisticsModal = false;
      this.text_modal = true;
      this.modal_data.reject = true;
      this.modal_data.success = false;
    },
    openSuccessModal() {
      this.sendStatisticsModal = false;
      this.showRatingModal = true;
      this.modal_data.success = true;
      this.modal_data.reject = false;
    },
    set_applications(data) {
      // if (!this.applications.length) {
      //   data.forEach((item) => this.applications.push(item))
      // } else {
      //   data.forEach((item) => {
      //       let idx = this.applications.findIndex((sub_item) => sub_item.id === item.id);
      //       if (idx > -1) return;
      //       else this.applications.push(item);
      //     }
      //   )
      // }
      this.applications = cloneDeep(data);
    },
    show_popover() {
      if (this.pop_is_open) return;
      this.pop_is_open = true;
      this.$nextTick(() => {
        this.setup_popover();
      });
    },
    setup_popover() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.confirm, this.$refs.warning, {
          placement: 'top',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
    close_popover() {
      if (!this.pop_is_open) return;
      this.pop_is_open = false;
    },
    allResultsFilled() {
      this.seria.forEach((item) => {
        if (item.works_with_results === true && item.results_filled === true) {
          this.all_results_filled = true;
        }
        if (item.works_with_results === false && item.results_filled === false) {
          this.all_results_filled = true;
        }
        if (item.works_with_results === true && item.results_filled === false) {
          this.all_results_filled = false;
        }
      });
    },
    closeTextModal() {
      this.modal_data = {};
      this.text_modal = false;
      this.sendStatisticsModal = false;
      this.$emit('updateEvent');
    },
  },
  beforeDestroy() {
    if (this.popper) this.popper.destroy();
  },
  watch: {
    seria() {
      this.allResultsFilled();
    },
  },
  computed: {
    seria_length() {
      return this.serias[this.seria[0].event_record_id];
    },
    allEventsStatFill() {
      return this.seria.every(item => item.is_filled);
    },
    buttonEnabled() {
      return (this.allEventsStatFill) && this.all_results_filled
          && this.seria_length === this.seria.length;
    },
  },
};
</script>

<style scoped>
</style>
